var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 11,
    viewBox: "0 0 8 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4849_15915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.1949 8.68123C2.24449 8.7039 2.29954 8.71187 2.35353 8.70419C2.40751 8.69651 2.45815 8.6735 2.49945 8.63789L4.65743 6.78071L7.49818 6.58955C7.55257 6.58587 7.60477 6.56668 7.64859 6.53426C7.69242 6.50184 7.72604 6.45754 7.74548 6.40661C7.76491 6.35568 7.76935 6.30024 7.75827 6.24687C7.74718 6.19349 7.72103 6.14441 7.68292 6.10543L2.48929 0.792849C2.44958 0.752246 2.39865 0.724419 2.34303 0.71293C2.28741 0.701441 2.22963 0.706813 2.17708 0.728358C2.12453 0.749902 2.07961 0.78664 2.04806 0.833867C2.01652 0.881094 1.99978 0.936661 2 0.993454L2.02802 8.42279C2.02824 8.47731 2.04407 8.53063 2.07365 8.57643C2.10322 8.62223 2.1453 8.6586 2.1949 8.68123ZM6.84227 6.06169L4.52408 6.21773C4.4625 6.22186 4.40393 6.24589 4.3572 6.28621L2.59626 7.8018L2.57329 1.69505L6.84227 6.06169Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4849_15915"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 10.7339,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewsIcon);
export default __webpack_public_path__ + "static/media/views-icon.991fa2a35cbe19a2e543238b8ad66b87.svg";
export { ForwardRef as ReactComponent };